import { render, staticRenderFns } from "./ButtonWithText.vue?vue&type=template&id=de38bbf0&scoped=true&"
import script from "./ButtonWithText.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithText.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonWithText.vue?vue&type=style&index=0&id=de38bbf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de38bbf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
